/**
 * Agencies Page Tour Steps
 * Tour for agency management features
 * Based on recommendations from react-joyride.md
 */
import { Step } from "react-joyride";

export const agenciesSteps: Step[] = [
  {
    target: "body",
    content:
      "Welcome to Agency/Team Management! Manage your agency partners and teams, track their agent counts, and organize them with tags.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tour="search-bar"]',
    content:
      "Search for agencies by name or use filters to narrow down the list. Find agencies quickly by status, owner, or tags.",
    placement: "bottom",
  },
  {
    target: '[data-tour="filter-drawer"]',
    content:
      "Open advanced filters to segment agencies by tags, creation date, and other criteria.",
    placement: "bottom",
  },
  {
    target: '[data-tour="create-agency"]',
    content:
      "Click Add Agency to create a new agency partner record. Assign an owner, set their stage, and add relevant tags.",
    placement: "bottom",
  },
  {
    target: '[data-tour="agency-table"]',
    content:
      "View all agencies in this table. See agency name, number of agents, stage, owner, and creation date at a glance.",
    placement: "top",
  },
  {
    target: '[data-tour="agency-actions"]',
    content:
      "Use these actions to view detailed agency information or remove an agency from your system.",
    placement: "left",
  },
];
